import axios from "axios";
// eslint-disable-next-line no-unused-vars
import router from "../router";
import { errorMsg } from "@/helpers/alerts.js";
// eslint-disable-next-line no-unused-vars
import { GetToken } from "@/helpers/encrypt";
import { useAuthStore } from "@/store/auth";
// import { getUrlData } from "../helpers/appUrl";
// const { url } = getUrlData();
const baseURL = process.env.VUE_APP_BASEURL;
export const AxiosClient = axios.create({
  baseURL: baseURL,
  // baseURL: "https://ik2fyv5rwd.kssqaa.org/vn",
  // baseURL: url,
});
AxiosClient.interceptors.request.use((config) => {
  const token = GetToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});
AxiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      // Handle 401 error (Unauthorized)
      useAuthStore().logout();
      router.push({ name: "login" });
    } else if (error.response.status === 409) {
      // Handle 409 error (Not Found)
      errorMsg(error.response.data.message).then(() => {
        // Redirect to dashboard or any other page
        router.push({ name: "dashboard" });
      });
    } else if (error.response.status === 404) {
      // Handle 404 error (Not Found)
      errorMsg(error.response.data.message).then(() => {
        // Redirect to dashboard or any other page
        router.push({ name: "dashboard" });
      });
    }
    return Promise.reject(error);
  },
);
